import { makeStyles } from "@material-ui/core"

import { colors } from "@/styles/colors"

const useStyles = makeStyles(() => ({
	optionRow: {
		gap: 0
	},
	optionLabelWrapper: {
		display: "flex",
		alignItems: "center"
	},
	optionLabel: {
		fontSize: 14,
		color: colors.gray[800]
	}
}))

export default useStyles
